(function(){
  function q(sel, ctx){ return (ctx||document).querySelector(sel); }
  function qa(sel, ctx){ return Array.from((ctx||document).querySelectorAll(sel)); }

  function init(wrapper){
    const tabs = qa('.br-tab', wrapper);
    const rentPrice = q('.br-price--rent', wrapper);
    const rentAction = q('.br-action--rent', wrapper);
    const defaultMode = (wrapper.getAttribute('data-default-mode') || 'buy').toLowerCase();

    function setMode(mode){
      const isRent = mode === 'rent';
      // aria state on tabs
      tabs.forEach(btn => btn.setAttribute('aria-selected', btn.dataset.mode === mode ? 'true' : 'false'));
      // show/hide elements
      if (rentPrice) rentPrice.hidden = !isRent;
      if (rentAction) rentAction.hidden = !isRent;
      // tell CSS what to hide/show elsewhere (ATC, dynamic checkout, big price)
      document.body.dataset.purchaseMode = mode;
    }

    tabs.forEach(btn => btn.addEventListener('click', () => setMode(btn.dataset.mode)));

    // init
    setMode(defaultMode === 'rent' ? 'rent' : 'buy');
  }

  document.addEventListener('DOMContentLoaded', function(){
    qa('.buy-rent-wrapper[data-has-rental="true"]').forEach(init);
  });
})();

// === Fix alignment of the Shop "Sign in" button ===
(function () {
  function styleShopLogin(el) {
    // Style the host (what you CAN reach with CSS)
    el.style.display = 'block';
    el.style.margin = '0'; // remove outside margin

    // Style the real button inside the shadow root
    const root = el.shadowRoot;
    if (root) {
      const btn = root.querySelector('button');
      if (btn) {
        btn.style.margin = '0';      // kill the internal m-auto centering
      }
    }
  }

  function scan() {
    document.querySelectorAll('shop-login-button').forEach(styleShopLogin);
  }

  // Run once DOM is ready…
  document.addEventListener('DOMContentLoaded', scan);

  // …and also whenever the element is injected/hydrated later
  const mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
